import { GzCollapsableContainerWebComponent } from './component/GzCollapsableContainerWebComponent';
import { WEB_COMPONENT_GZ_COLLAPSABLE_CONTAINER } from '../../webcomponents.constants';

export { GzCollapsableContainerWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_COLLAPSABLE_CONTAINER, GzCollapsableContainerWebComponent);
